import { render, staticRenderFns } from "./FolderGrid.vue?vue&type=template&id=d267c922"
import script from "./FolderGrid.vue?vue&type=script&lang=js"
export * from "./FolderGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports